import { Text } from '~/components/ui/Text';
import { AppIcon } from '../AppIcon';
import { StyledContainer } from './AppButton.styled';

const AppButton = ({
	icon,
	text,
	onClick,
}: {
	icon: string;
	text: string;
	onClick: () => void;
}) => {
	return (
		<StyledContainer>
			<AppIcon icon={icon} onClick={onClick} />
			<Text>{text}</Text>
		</StyledContainer>
	);
};

export { AppButton };
